import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ eyebrow, title, text }) => (
  <Reveal className="max-w-2xl mb-14 md:mb-20">
    {eyebrow && (
      <p className="font-tech uppercase tracking-[0.4em] text-[10px] font-semibold text-cyan-300/80 mb-4">{eyebrow}</p>
    )}
    <h2 className="font-tech font-bold uppercase text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-silver-gradient">
      {title}
    </h2>
    {text && <p className="mt-5 text-base md:text-lg leading-relaxed text-[#A1A1AA]">{text}</p>}
  </Reveal>
);
